"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const util_ts_1 = require("@clipboard-health/util-ts");
const material_1 = require("@mui/material");
const Links_1 = require("../../Links");
const Span_1 = require("../../Span");
function BannerLink(props) {
    const { children, title, to, severity, onClose, onClick } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: severity, icon: false, sx: {
            paddingLeft: 0,
            paddingY: 0,
            borderRadius: 0,
            width: "100%",
            "& .MuiAlert-action": { paddingX: 0 },
            "& .MuiAlert-message": { padding: 0, width: "100%" },
        }, variant: "filled", ...((0, util_ts_1.isDefined)(onClose) && { onClose }), children: (0, jsx_runtime_1.jsxs)(Links_1.InternalLink, { to: to, underline: "none", color: "inherit", sx: {
                /**
                 * This is a CSS hack to center the banner content with relation to the close button action
                 * 38px is hard-coded based on action container width when the close button exists
                 * 16px is hard-coded based on the margin of the action container when the close button does not exist
                 */
                paddingLeft: (0, util_ts_1.isDefined)(onClose) ? "38px" : "16px",
                paddingY: 1,
                height: "100%",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                "&:hover": {
                    color: "inherit",
                },
            }, ...((0, util_ts_1.isDefined)(onClick) && { onClick }), children: [title && ((0, jsx_runtime_1.jsx)(Span_1.Span, { display: "block", children: (0, jsx_runtime_1.jsx)("b", { children: title }) })), children] }) }));
}
exports.BannerLink = BannerLink;
//# sourceMappingURL=BannerLink.js.map